<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.equivalencesProfessionnelles"
      add-new-text="Ajouter une expérience professionnelle"
      :live="{ endpoint: 'sas-equivalence-professionnelle', sasId: sas.id }"
      optional
      card-width="900"
      :icon="$getIcon('expPro')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.nomDeLEtablissement }}</h3>
        <p class="my-0">{{ item.posteOccupe }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-text-field code="nom-organisation-emploi" v-model="item.nomDeLEtablissement" :live="liveSasExpPro(7202, item)"></opq-text-field>
        <opq-text-field code="titre-poste-emploi" v-model="item.posteOccupe" :live="liveSasExpPro(7203, item)"></opq-text-field>
        <opq-date-picker code="debut-emploi" v-model="item.dateDeDebutDEmploi" :live="liveSasExpPro(7204, item)"></opq-date-picker>
        <opq-date-picker code="fin-emploi" v-model="item.dateDeFinDEmploi" :live="liveSasExpPro(7205, item)"></opq-date-picker>
        <opq-memo code="fonctions-emploi" v-model="item.principalesFonctionsExercees" :live="liveSasExpPro(7210, item)"></opq-memo>
        <opq-text-field code="nombre-jours-emploi" v-model="item.nombreDeJoursTravailles" :live="liveSasExpPro(7206, item)" isNumber></opq-text-field>
        <opq-text-field
          code="nombre-heures-emploi"
          v-model="item.nombreDHeuresTravaillees"
          :live="liveSasExpPro(7207, item)"
          isNumber
        ></opq-text-field>
        <opq-catalogue code="secteur-pratique-emploi" v-model="item.secteurDePratique" :live="liveSasExpPro(7208, item)"></opq-catalogue>
        <opq-catalogue code="type-emploi" v-model="item.typeDEmploi" :live="liveSasExpPro(7209, item)"></opq-catalogue>
        <opq-memo code="modalites-evaluation-emploi" v-model="item.modalitesDEvaluation" :live="liveSasExpPro(7211, item)"></opq-memo>
        <opq-memo code="types-interventions-emploi" v-model="item.typesDIntervention" :live="liveSasExpPro(7212, item)"></opq-memo>
        <opq-memo code="superieur-emploi" v-model="item.superieur" :live="liveSasExpPro(7213, item)"></opq-memo>
        <opq-catalogue code="supervision-emploi" v-model="item.supervision" :live="liveSasExpPro(7214, item)"></opq-catalogue>
        <opq-memo
          :opq-if="estOui(item.supervision)"
          code="superviseur-emploi"
          v-model="item.titreEtQualificationsDeVotreSuperviseur"
          :live="liveSasExpPro(7217, item)"
        ></opq-memo>
        <opq-catalogue
          :opq-if="estOui(item.supervision)"
          code="type-supervision-emploi"
          v-model="item.typeSupervision"
          :live="liveSasExpPro(7215, item)"
        ></opq-catalogue>
        <opq-text-field
          :opq-if="estOui(item.supervision)"
          code="frequence-supervision-emploi"
          v-model="item.frequenceDeSupervision"
          :live="liveSasExpPro(7216, item)"
        ></opq-text-field>
        <opq-memo code="pertinence-emploi" v-model="item.pertinenceExperienceDeTravail" :live="liveSasExpPro(7219, item)"></opq-memo>
        <opq-file-multiple code="attestation-emploi" :files="item.attestationDEmploi" :live="liveSasExpPro(7218, item)"></opq-file-multiple>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasExpPro(cle, item) {
      return { endpoint: "sas-equivalence-professionnelle", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>